import React from "react";
import { formatDistanceStrict } from "date-fns";

import { Grid, Typography } from "@material-ui/core";

const AuditSummary = ({ currentAudit }) => {
  let matchCount = 0;
  let noMatchCount = 0;
  let itemsNotFound = 0;

  currentAudit?.processedItems?.length > 0 &&
    currentAudit.processedItems.forEach((itm) => {
      if (itm.quantityPhysical === 0) itemsNotFound++;
      else if (itm.quantityPhysical !== itm.quantityOnHand) noMatchCount++;
      else if (itm.quantityPhysical === itm.quantityOnHand) matchCount++;
    });

  return (
    <Grid container spacing="2">
      <Grid item sm={12}>
        <Typography>
          Total items processed: {currentAudit.processedItems.length}
        </Typography>
      </Grid>
      <Grid item sm={12}>
        <Typography>Items matched: {matchCount}</Typography>
      </Grid>
      <Grid item sm={12}>
        <Typography>Items not matched: {noMatchCount}</Typography>
      </Grid>
      <Grid item sm={12}>
        <Typography>Missing items: {itemsNotFound}</Typography>
      </Grid>
      {currentAudit?.startDateTime && currentAudit?.endDateTime && (
        <Grid item sm={12}>
          <Typography>
            Audit Duration:{" "}
            {formatDistanceStrict(
              new Date(currentAudit.startDateTime),
              new Date(currentAudit.endDateTime)
            )}
          </Typography>
        </Grid>
      )}
      <Grid item sm={12}></Grid>
    </Grid>
  );
};

export default AuditSummary;
